import { DialogComponent, DialogOpenEvent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener(DialogOpenEvent.eventName, this.#kickCartThumbnails);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener(DialogOpenEvent.eventName, this.#kickCartThumbnails);
  }

  /**
   * Some browsers defer or skip lazy-loaded images inside closed dialogs; nudge failed loads after open.
   */
  #kickCartThumbnails = () => {
    const reloadIfBroken = () => {
      for (const img of this.querySelectorAll('.cart-items__media-image')) {
        if (!(img instanceof HTMLImageElement) || !img.src) continue;
        if (img.naturalWidth > 0) continue;
        if (!img.complete) continue;
        const src = img.src;
        img.removeAttribute('src');
        img.src = src;
      }
    };
    requestAnimationFrame(reloadIfBroken);
    setTimeout(reloadIfBroken, 300);
  };

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
